module.exports = "<a href=\"#\" id=\"pause-resume\">Pause ||</a>\n<a href=\"#\" id=\"skip-animation\">Skip Animation --></a>\n<span style=\"float:right\">\n<a href=\"https://github.com/kevogich\">GitHub</a>\n<a href=\"\">View Source</a>\n</span>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./header.html
 ** module id = 83
 ** module chunks = 0 1
 **/